import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as trimCanvasMod from "trim-canvas";

import { notifyUser } from "../utils/notifyUser";

const trimCanvas = trimCanvasMod.default || trimCanvasMod;

export default function InvestorConsent() {
    const navigate = useNavigate();
    const sigRef = useRef(null);
    const [typedName, setName] = useState("");
    const today = () => new Date().toISOString().slice(0, 10);
    const [sigDate, setDate] = useState(today());
    const [accepted, setAccepted] = useState(false);

    const [padHasInk] = useState(false);

    const onContinue = () => {
        if(!accepted) {
            notifyUser(null, "error", "Please accept the terms.", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }
        if(!typedName.trim() && !padHasInk) {
            notifyUser(null, "error", "Enter your full name.", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }
        if(!sigDate) {
            notifyUser(null, "error", "Please select a date.", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }

        let sigDataUrl = "";
        if(padHasInk) {
            const raw = sigRef.current.getCanvas();
            const trimmed = trimCanvas(raw);
            sigDataUrl = trimmed.toDataURL("image/png");
        }

        localStorage.setItem("investorSignature", sigDataUrl);
        localStorage.setItem("investorSignatureName", typedName.trim());
        localStorage.setItem("investorSignatureDate", sigDate);

        navigate("/investor-application");
    };

    /* ───────── UI ───────── */
    return (
        <div className="font-poppins">
            <div className="min-h-[60vh] flex items-center justify-center bg-white px-4 py-4 relative">
                <div className="w-full max-w-3xl text-center">
                    {/* Consent message and links above the form */}
                    <img
                        src="images/AeQuitas-Logo-blue-with-text.png"
                        alt="AQI Logo"
                        className="w-48 mx-auto mb-2 sm:mb-4 sm:w-60 md:w-72"
                    />

                    <h1 className="text-3xl font-bold text-navy mt-2">
                        Terms and Conditions
                    </h1>

                    {/* signature block */}
                    <div className="mb-6 space-y-2 text-left">
                        {/* typed fallback */}
                        <label className="block text-navy font-semibold mb-1 mt-4">
                            Enter your full name below:
                        </label>
                        <input
                            type="text"
                            value={typedName}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter your full name"
                            className="w-full px-4 py-2 border border-navy rounded-lg"
                        />

                        {/* date */}
                        <label className="block text-navy font-semibold mb-1 mt-4">
                            Date:
                        </label>
                        <input
                            type="date"
                            value={sigDate}
                            onChange={(e) => setDate(e.target.value)}
                            className="w-full px-4 py-2 border border-navy rounded-lg"
                        />
                    </div>

                    {/* acceptance checkbox */}
                    <div className="flex items-start gap-2 mb-6 text-left">
                        <input
                            type="checkbox"
                            id="agree"
                            checked={accepted}
                            onChange={() => setAccepted(!accepted)}
                            className="mt-1"
                        />
                        <label
                            htmlFor="agree"
                            className="text-navy text-sm"
                        >
                            <p className="text-navy text-sm md:text-md text-center justify-center italic font-poppins font-medium mb-6 ">
                                By Continuing, you agree to the{" "}
                                <a
                                    href="/docs/terms_of_use_10_2026.pdf"
                                    target="_blank"
                                    className="underline text-navy"
                                >
                                    Terms and Conditions
                                </a>
                                ,{" "}
                                <a
                                    href="/docs/privacy_policy_10_2026.pdf"
                                    target="_blank"
                                    className="underline text-navy"
                                >
                                    Privacy Policy
                                </a>
                                ,{" "}
                                <a
                                    href="/docs/investor_agreement_05_2026.pdf"
                                    target="_blank"
                                    className="underline text-navy"
                                >
                                    Investor Agreement
                                </a>
                                ,{" "}
                                <a
                                    href="/docs/electronic_delivery_of_documents_11_2025.pdf"
                                    target="_blank"
                                    className="underline text-navy"
                                >
                                    Electronic Delivery of Documents
                                </a>{" "}
                            </p>
                        </label>
                    </div>

                    {/* actions */}
                    <div className="flex justify-center mt-4">
                        <button
                            onClick={onContinue}
                            className={`rounded-[6px] px-5 py-3 font-semibold shadow-sm transition ${
                                accepted
                                    ? "bg-navy text-paper hover:bg-navy-2"
                                    : "cursor-not-allowed bg-gray-300 text-gray-500"
                            }`}
                        >
                            Continue to Application
                        </button>
                    </div>
                    <p className="mt-3 sm:mt-4 text-sm sm:text-md text-navy italic font-poppins px-2 mt-2">
                        Are you an Entrepreneur who wants to raise money? Start
                        an&nbsp;
                        <span
                            className="text-navy underline cursor-pointer"
                            onClick={() => {
                                const url = new URL(
                                    "/sign-up",
                                    window.location.origin,
                                );
                                url.searchParams.set(
                                    "openEntrepreneurModal",
                                    "true",
                                );
                                window.open(url.toString(), "_blank");
                            }}
                        >
                            Entrepreneur Account
                        </span>{" "}
                        instead.
                    </p>
                </div>
            </div>
        </div>
    );
}
